import { render, staticRenderFns } from "./CaseMixin.vue?vue&type=template&id=b65e3948&"
import script from "./CaseMixin.vue?vue&type=script&lang=js&"
export * from "./CaseMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports